"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactPlayer = _interopRequireDefault(require("react-player"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Video = ({
  src,
  intersectionObserver = false,
  controls = true,
  poster,
  config = {
    file: {
      attributes: {
        controlsList: 'nodownload noplaybackrate'
      }
    }
  },
  playing = false,
  autoPlay = false,
  height = 'auto',
  width = '100%',
  css,
  onPause,
  onPlay,
  ...restProps
}) => {
  const containerRef = (0, _react.useRef)(null);

  /** Determines if the video controls have been physically interacted with  */
  const [playPressed, setPlayPressed] = (0, _react.useState)(false);
  /** The play state of the player */
  const [isPlaying, setIsPlaying] = (0, _react.useState)(playing);
  const videoSrc = src || undefined;
  const posterSrc = poster || undefined;
  const intersectionObsOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };
  const intersectionCallback = entries => {
    const [entry] = entries;
    // If the video is in the viewport and autoPlay is true or the user has physically pressed play, start playing
    if (entry.isIntersecting && (autoPlay || playPressed)) {
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
    }
  };
  (0, _react.useEffect)(() => {
    if (!intersectionObserver || !window.IntersectionObserver) return;
    const observer = new IntersectionObserver(intersectionCallback, intersectionObsOptions);
    const currentRef = containerRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerRef.current, intersectionObsOptions, intersectionObserver]);
  const handlePlay = () => {
    setPlayPressed(true);
    onPlay && onPlay();
  };
  const handlePause = () => {
    setPlayPressed(false);
    onPause && onPause();
  };
  return (0, _jsxRuntime.jsx)(_styles.PlayerContainer, {
    ref: containerRef,
    children: (0, _jsxRuntime.jsx)(_reactPlayer.default, {
      url: videoSrc,
      controls: controls,
      playing: isPlaying,
      light: posterSrc ?? false,
      width: width,
      height: height,
      config: config,
      onPlay: handlePlay,
      onPause: handlePause,
      css: () => [css && css],
      ...restProps
    })
  });
};
var _default = exports.default = Video;